import {api} from 'lib/url'
import {useEvent} from 'Event/EventProvider'
import {Property} from 'organization/Event/Services/Apps/HubspotV2/Config/HubspotV2PropertiesProvider'
import {Attendee} from 'Event/attendee'
import {useOrganization} from 'organization/OrganizationProvider'

export type HubspotV2Tag = {
  property_label: string | null
  property_name: string | null
  property_type: Property['type'] | null
  property_value: string | null
}

export function useAddTag() {
  const {client, event} = useEvent()

  const url = api(`/events/${event.id}/integrations/hubspot_v2/add_tag`)
  return (tag: HubspotV2Tag) => {
    try {
      client.post(url, tag)
    } catch {
      // Ignore errors, failing to add a tag should
      // not break the app.
    }
  }
}

export function useTestTag() {
  const {event} = useEvent()
  const {client} = useOrganization()

  const url = api(`/events/${event.id}/integrations/hubspot_v2/test_tag`)
  return async (tag: HubspotV2Tag, attendee: Attendee): Promise<void> => {
    return await client.post(url, {
      tag,
      attendee_id: attendee.id,
    })
  }
}
